import css from 'styled-jsx/css';
import { colors } from '../../../themes';

export default css`
  .publish_your_cv {
    padding: 1em;
    background-color: ${colors.grayExtraLight};
    text-align: center;
  }
`;



// WEBPACK FOOTER //
// ./app/Serp/components/PublishYourCv/styles.js